import React from 'react';
import { Modal } from 'react-bootstrap';
import { VISIT_STATUS_CLASS } from '../../Utils/patientVisits';
import '../../App.css';

function DetailRow({ label, value }) {
  return (
    <div className="col-md-6 mb-3">
      <div className="text-muted small">{label}</div>
      <div className="fw-semibold">{value || '—'}</div>
    </div>
  );
}

function VisitDetailsModal({ show, visit, onHide }) {
  if (!visit) return null;

  const statusClass = VISIT_STATUS_CLASS[visit.status] || '';
  const isCancelled = visit.status === 'cancelled';

  return (
    <Modal show={show} onHide={onHide} centered size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Visit Request Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <DetailRow label="Booking Number" value={visit.bookingNumber} />
          <div className="col-md-6 mb-3">
            <div className="text-muted small">Status</div>
            <span className={`patient-status-pill ${statusClass}`}>
              {visit.statusLabel}
            </span>
          </div>
          <DetailRow label="Service Type" value={visit.serviceType} />
          <DetailRow label="Amount" value={visit.amount} />
          <DetailRow label="Preferred Date" value={visit.preferredDate} />
          <DetailRow label="Preferred Time (IST 🇮🇳)" value={visit.preferredTime} />
          <div className="col-12 mb-3">
            <div className="text-muted small">Symptoms / Description</div>
            <div className="fw-semibold" style={{ whiteSpace: 'pre-wrap' }}>
              {visit.description || '—'}
            </div>
          </div>
          {visit.additionalNotes ? (
            <div className="col-12 mb-3">
              <div className="text-muted small">Additional Notes</div>
              <div className="fw-semibold" style={{ whiteSpace: 'pre-wrap' }}>
                {visit.additionalNotes}
              </div>
            </div>
          ) : null}
          {isCancelled ? (
            <div className="col-12 mb-3">
              <div className="text-muted small">Cancellation Reason</div>
              <div className="fw-semibold" style={{ whiteSpace: 'pre-wrap' }}>
                {visit.cancelReason || '—'}
              </div>
            </div>
          ) : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn login-submit-btn" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default VisitDetailsModal;
